import * as QueryStringHelper from './QueryStringHelper';

export function getReferrerEncoded() {
    return encodeURIComponent(QueryStringHelper.getQueryStringParameter('_r') || document.referrer);
}
